import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSidebarOpenIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.75,
			y: 2.75,
			width: 12.5,
			height: 10.5,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "m6.5 6-2 2 2 2" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 3.5h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2v-9Z",
			fill: "currentColor"
		})
	]
});
export default SvgSidebarOpenIcon;
